import WebsiteIcon from 'Components/Atoms/Icons/WebsiteIcon/WebsiteIcon';
import FormGroup from 'Components/Molecules/Form/FormGroup/FormGroup';
import Field from 'Pages/Dashboard/Settings/FieldsManagement/Fields/FieldTypes/Field';
import { connect } from 'react-redux';
import { StoreState } from 'Store/Reducers';
import { getFieldsById } from 'Store/Settings/Fields/Selectors';

const CategoryOverview = ({
    fields, values,
    fieldsById
}: CategoryOverviewProps) => {
    return fields?.map(i => {
        const field = fieldsById?.[i];
        return <FormGroup
            title={`${field?.name} ${field?.required ? '*' : ''}`}
            iconAfter={field?.is_public ? <WebsiteIcon /> : ''}
        >
            <Field
                isEdit={false}
                value={values?.[field.id]?.value}
                type={field?.type}
                fieldProperties={{
                    ...field?.default,
                    alignLeft: true
                }}
            />
        </FormGroup>
    });
}

interface Props {
    fields: any
    values: any
};

const mapState = (state: StoreState, props: Props) => ({
    fieldsById: getFieldsById(state)
});

const mapDispatch = {
    
};

type CategoryOverviewProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(CategoryOverview);